/*
export function someMutation (state) {
}
*/
export const updateDrawerState = (state, opened) => {
    state.drawerState = opened
}

export const updateCurrAssessmentState = (state, opened) => {
    state.currAssessmentState = opened
}